import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import type { GetProductsResponse } from '@dtp/membership-service-types';
import { Actions, actions } from '@redux/modules/becomeAMember';
import { TypedEpic } from './types';

export const getBecomeAMemberEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_BECOME_A_MEMBER),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getBecomeAMember.request>[]
    >,
    switchMap(([action]) => {
      const params = action.payload ? { campaignCode: action.payload } : undefined;

      return fromApiRequest((signal) =>
        apiClient.get<GetProductsResponse>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].v2.products,
          params,
        }),
      ).pipe(
        map((response) => actions.getBecomeAMember.success(response.data)),
        catchError((err) => of(actions.getBecomeAMember.failure(toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE)))),
      );
    }),
  );

export const epics: TypedEpic[] = [getBecomeAMemberEpic];
